// extracted by mini-css-extract-plugin
export var checkbox = "_6g-0";
export var circle = "_6g-3";
export var horizontalContainer = "_6g-7";
export var sm = "_6g-5";
export var switch0 = "_6g-2";
export var switchDisabled = "_6g-8";
export var switchEnabled = "_6g-1";
export var textSwitchContainer = "_6g-9";
export var textSwitchOption = "_6g-a";
export var textSwitchOptionSelected = "_6g-b";
export var verticalContainer = "_6g-6";
export var xs = "_6g-4";